var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheque(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_94_3252",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_94_3252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 19V5H22V19H2ZM5 14H8C8.28333 14 8.52083 13.9042 8.7125 13.7125C8.90417 13.5208 9 13.2833 9 13V11.25C9 10.9667 8.90417 10.7292 8.7125 10.5375C8.52083 10.3458 8.28333 10.25 8 10.25H6.5V9.5H9V8H5V11.75H7.5V12.5H5V14ZM11 16H19V15.45C19 14.7 18.6333 14.1042 17.9 13.6625C17.1667 13.2208 16.2 13 15 13C13.8 13 12.8333 13.2208 12.1 13.6625C11.3667 14.1042 11 14.7 11 15.45V16ZM15 12C15.55 12 16.0208 11.8042 16.4125 11.4125C16.8042 11.0208 17 10.55 17 10C17 9.45 16.8042 8.97917 16.4125 8.5875C16.0208 8.19583 15.55 8 15 8C14.45 8 13.9792 8.19583 13.5875 8.5875C13.1958 8.97917 13 9.45 13 10C13 10.55 13.1958 11.0208 13.5875 11.4125C13.9792 11.8042 14.45 12 15 12ZM4 17H20V7H4V17Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheque);
export default __webpack_public_path__ + "static/media/cheque.2069d1151241f19eb792e13e3106f159.svg";
export { ForwardRef as ReactComponent };